import CardContent from 'components/Base/Layout/Content/CardContent';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { TPartsUI } from 'data/types/workshops.types';
import { combineDateAndTime, formatStringToTitleCase } from 'helpers/utils';
import { TabBodyWrapper } from 'components/Base/Tabs';
import AttendanceList from './AttendanceList';
import { TAttendanceListTabProps } from './AttendanceTab.types';

const AttendanceTab = ({ data }: TAttendanceListTabProps) => {
  const sessions = data?.parts || [];

  const renderAttendance = (session: TPartsUI) => {
    const dateTime = combineDateAndTime(session.date?.value, session.startTime);

    return (
      <div key={session.partType}>
        <CardContent tabContent contentPadding="8px 0px">
          <AttendanceList
            title={`${formatStringToTitleCase(session.partType)}${
              dateTime ? ` - ${dateTime}` : ''
            }`}
            sessionDateTime={dateTime}
            workshopId={data?.id || ''}
            workshopStatus={data?.status}
            workshopType={data?.type}
            customQuestion={data?.customQuestion.value}
            hideChildInfo={!!data?.isCCP}
            partType={session.partType}
            sessions={sessions}
          />
        </CardContent>
      </div>
    );
  };

  const items: TabsProps['items'] = (sessions || []).map((session, index) => {
    const dateTime = combineDateAndTime(session.date?.value, session.startTime);
    return {
      key: index.toString(),
      label: `${formatStringToTitleCase(session.partType)}${
        dateTime ? ` • ${dateTime}` : ''
      }`,
      children: renderAttendance(session),
    };
  });

  if (!data) return null;

  return (
    <TabBodyWrapper isEmpty={!items.length} emptyText="No Attendance data yet.">
      <Tabs
        defaultActiveKey="0"
        items={items}
        tabBarStyle={{ margin: '-16px -16px 0 -16px' }}
      />
    </TabBodyWrapper>
  );
};

export default AttendanceTab;
